import React from "react";

import { templates } from "@reactivated";

import { AccountShell } from "../components/AccountShell";
import { OrderDetail } from "../components/OrderDetail";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.OrderDetailDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <AccountShell
            hasNav={props.has_nav}
            sideNav={props.side_nav}
            title={props.content_title}
            phoneDisplay={props.phone_display}
            phoneHref={props.phone_href}
        >
            {props.order_detail && <OrderDetail data={props.order_detail} />}
        </AccountShell>
    </PageSkeleton>
);
